import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState, Fragment } from "react";
import downloadFileFromS3, { currencyFormatter, isShowPriceAccordingToProcess, numberInputOnWheelPreventChange } from "../../../../utils/helper";
import { ArrowDown, ArrowUp, DeleteIcon, DownloadIcon } from "../../../../components/Icons";
import AutoResizingTextarea from "../../../../components/AutoResizeTextAreaComponent/AutoResizeTextAreaComponent";
import DynamicWidthInput from "../../../../components/AutoResizeTextAreaComponent/DynamicWithInput";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { AsyncIterator } from "regenerator-runtime";
import axios from "axios";
import ThreeDViewerComponent from "../../../../components/ViewerComponent/ThreeDViewerComponent";
import { CREATE_QUOTE_ACTION, useCreateQuoteContext } from "../../../../context/create.quote.context";
import SmallGlobalLoader from "../../../../components/LoaderComponent/LoaderComponent";
import { setValues } from "../../../../context/create.quote.actions";

const ManualProcessLinesUI = (props) => {
  const { isGlobalLoading, selectedQuote } = props;

  console.log("Global Loading :", isGlobalLoading);

  let { quoteId } = useParams();
  let index = props.index;
  let val = props.values[index];
  const [itemDescription, setItemDescription] = useState("");
  const [itemNotes, setItemNotes] = useState(val.Notes);
  const [itemQuantity, setItemQuantity] = useState(val.Qty);
  const [linePartName, setLinePartName] = useState(val.linePartName);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const repeatOrder = searchParams.get('RepeatOrder') == "true" ? true : false;
  const isRepeatOrderWithUpdate = searchParams.get('isRepeatOrderWithUpdate') == "true" ? true : false;
  const [isViewerLoading, setIsViewerLoading] = useState(false);
  const { createQuoteState, createQuoteDispatch } = useCreateQuoteContext();


  const handleChangeRouteForRepeatOrder = () => {
    // let userConfirmation = confirm("Are you sure you want to change the selected files for the previous quotation? This action will generate a new version of the quotation, which will require admin review before you can proceed with creating an order.");
    if (userConfirmation) {
      navigate(`/create-instant-quotation/${quoteId}?isRepeatOrderWithUpdate=true`)
    }
  }


  useEffect(() => {
    if (quoteId) {
      setItemDescription(props.values[index].description)
      setItemNotes(props.values[index].Notes)
      setLinePartName(props.values[index].linePartName)
    }
  }, [])

  useEffect(() => {
    if (quoteId) {
      setItemDescription(props.values[index].description)
      setItemNotes(props.values[index].Notes)
      setLinePartName(props.values[index].linePartName)
    }
  }, [props.values]);


  useEffect(() => {
    if (val?.Qty == 0) {
      onQuantityChange(1);
    }

  }, [val.Qty])


  const onDescriptionChange = (event) => {
    if (repeatOrder) {
      handleChangeRouteForRepeatOrder()
      return;
    }
    setItemDescription(event.target.value);
    val.description = event.target.value;

    const updatedCommanValues = { ...createQuoteState?.commanValues };
    updatedCommanValues.isQuoteChanged = true;
    createQuoteDispatch({
      type: CREATE_QUOTE_ACTION.UPDATE_COMMAN_VALUES,
      payload: updatedCommanValues,
    });
  }

  const handlePartNameChange = (event) => {
    if (repeatOrder) {
      handleChangeRouteForRepeatOrder()
      return;
    }
    setLinePartName(event.target.value)
    val.linePartName = event.target.value;


    const updatedCommanValues = { ...createQuoteState?.commanValues };
    updatedCommanValues.isQuoteChanged = true;
    createQuoteDispatch({
      type: CREATE_QUOTE_ACTION.UPDATE_COMMAN_VALUES,
      payload: updatedCommanValues,
    });
  }



  const onQuantityChange = (value) => {
    // console.log("Value :", value);
    if (repeatOrder) {
      handleChangeRouteForRepeatOrder()
      return;
    }
    let percent = 0;
    props.updateValueOnChange(props.index, "Qty", parseInt(value), percent);
    const updatedCommanValues = { ...createQuoteState?.commanValues };
    updatedCommanValues.isQuoteChanged = true;
    createQuoteDispatch({
      type: CREATE_QUOTE_ACTION.UPDATE_COMMAN_VALUES,
      payload: updatedCommanValues,
    });
  }






  console.log("Val :", val);
  const moveLineItemToXindex = (index, direction) => {
    // 1
    //   - 1


    const values = createQuoteState?.values;
    const tempValue = JSON.parse(JSON.stringify(values[index + direction]))

    console.log("Values To Change :", values[index]);
    values[index + direction] = values[index];
    values[index] = tempValue;
    setValues([...values], createQuoteDispatch, createQuoteState);
    const updatedCommanValues = { ...createQuoteState?.commanValues };
    updatedCommanValues.isQuoteChanged = true;
    createQuoteDispatch({
      type: CREATE_QUOTE_ACTION.UPDATE_COMMAN_VALUES,
      payload: updatedCommanValues,
    });
  }


  return (
    <Fragment >
      {
        (val.selectedFile) ? (
          <tr key={index} >
            <td className="flex items-center justify-start  ">
              {props.values.length !== 1 ? (
                <div
                  className="flex mx-1  flex-col justify-between gap-y-3 w-[50px] items-center col-span-1 py-2 rounded-lg "
                >
                  {props?.index != 0 && (
                    <Button
                      className="border border-gray-300 rounded p-2 w-8 h-8  transition-all"
                      variant="outline"
                      onClick={() => moveLineItemToXindex(props?.index, -1)}
                    >
                      <ArrowUp additionalClasses="w-4 h-4" />
                    </Button>
                  )}
                  {props?.index != createQuoteState?.values?.length - 1 && (
                    <Button
                      className="border border-gray-300 rounded p-2 w-8 h-8  transition-all"
                      variant="outline"
                      onClick={() => moveLineItemToXindex(props?.index, 1)}
                    >
                      <ArrowDown additionalClasses="w-4 h-4" />
                    </Button>
                  )}
                </div>

              ) : null}
              <ThreeDViewerComponent
                item={val}
                selectedProcess={props?.selectedQuote?.selectedProcess}
                additionalClasses={'!border-0'}

              />
            </td>
            <td >
              {val?.selectedFile?.originalname ? <FileName
                fileName={val?.selectedFile?.originalname}
                onDownload={async () => await downloadFileFromS3(val?.selectedFile)}
              /> : null}
            </td>
            <td >
              <AutoResizingTextarea
                maxLength={150}
                value={itemDescription}
                readOnly={isGlobalLoading}
                onChange={onDescriptionChange}
                name={'descripton'}
              />
            </td>
            <td>
              <Form.Control
                name="quantity"
                type="number"
                className={`quantity  ${!props.singleValue.Qty || props.singleValue.Qty <= 0 ? "!border !border-red-500" : null}`}

                value={val.Qty}
                onChange={(e) => {
                  onQuantityChange(e.target.value);
                }}
                onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()} // Prevent invalid characters
                onWheel={(e) => e.target.blur()} // Prevent scrolling to change the value
                style={{ width: "64px" }}
                disabled={isGlobalLoading}
              />

            </td>
            {isShowPriceAccordingToProcess(selectedQuote) ? <td>
              {<div>
                {
                  (props?.commanValues?.selectedShipMethod === 1 && !isGlobalLoading && !props?.commanValues?.isQuoteChanged && props?.singleValue?.price1) ? (
                    <div className="flex flex-col font-medium me-2">
                      <div>{currencyFormatter(props?.singleValue?.price1 * props?.singleValue?.Qty)}</div>
                      <div>{currencyFormatter(props?.singleValue?.price1)} <span className="text-slate-500">Each</span></div>
                    </div>
                  ) : (props?.commanValues?.selectedShipMethod === 2 && !isGlobalLoading && !props?.commanValues?.isQuoteChanged && props?.singleValue?.price2) ? (
                    <div>
                      <div className="flex flex-col font-medium me-2">
                        <div>{currencyFormatter(props?.singleValue?.price2 * props?.singleValue?.Qty)}</div>
                        <div>{currencyFormatter(props?.singleValue?.price2)} <span className="text-slate-500">Each</span></div>
                      </div>
                    </div>
                  ) : (props?.commanValues?.selectedShipMethod === 3 && !isGlobalLoading && !props?.commanValues?.isQuoteChanged && props?.singleValue?.price3) ? (
                    <div>
                      <div className="flex flex-col font-medium me-2">
                        <div>{currencyFormatter(props?.singleValue?.price3 * props?.singleValue?.Qty)}</div>
                        <div>{currencyFormatter(props?.singleValue?.price3)} <span className="text-slate-500">Each</span></div>
                      </div>
                    </div>
                  ) : isGlobalLoading ?
                    <SmallGlobalLoader
                      height={70}
                    />
                    : null
                }

              </div>}
            </td> : null}

            <td className="text-center">
              {!isGlobalLoading ? <button
                className="px-2 py-1 mt-2 bg-red-500 text-white text-xs rounded-md flex items-center gap-1 hover:bg-red-600 transition duration-200"
                onClick={() => props.onDelete(index)}
              >
                Delete
              </button> : <button className="w-6"></button>}
            </td>
          </tr>)
          : (
            <tr key={index} >
              <td className="flex items-center justify-start ">
                {props.values.length !== 1 ? (
                  <div
                    className="flex mx-1  flex-col justify-between gap-y-3 w-[50px] items-center col-span-1 py-2 rounded-lg "
                  >
                    {props?.index != 0 && (
                      <Button
                        className="border border-gray-300 rounded p-2 w-8 h-8  transition-all"
                        variant="outline"
                        onClick={() => moveLineItemToXindex(props?.index, -1)}
                      >
                        <ArrowUp additionalClasses="w-4 h-4" />
                      </Button>
                    )}
                    {props?.index != createQuoteState?.values?.length - 1 && (
                      <Button
                        className="border border-gray-300 rounded p-2 w-8 h-8  transition-all"
                        variant="outline"
                        onClick={() => moveLineItemToXindex(props?.index, 1)}
                      >
                        <ArrowDown additionalClasses="w-4 h-4" />
                      </Button>
                    )}
                  </div>

                ) : null}
                <ThreeDViewerComponent
                  item={val}
                  selectedProcess={props?.selectedQuote?.selectedProcess}
                  additionalClasses={'!border-0'}
                />
              </td>
              <td>
                <Form.Control
                  name='linePartName'
                  className="part-name"
                  type="text"
                  value={linePartName}
                  placeholder="Enter part name here"
                  onChange={handlePartNameChange}
                  disabled={isGlobalLoading}
                />
              </td>
              <td >
                <AutoResizingTextarea
                  maxLength={150}
                  value={itemDescription}
                  readOnly={isGlobalLoading}
                  onChange={onDescriptionChange}
                  name={'descripton'}
                />
              </td>

              <td className=" items-center">
                <Form.Control
                  name="quantity"
                  type="number"
                  className={`quantity    ${!props.singleValue.Qty || props.singleValue.Qty <= 0 ? "!border !border-red-500" : null}`}
                  value={val.Qty}
                  onChange={(e) => {
                    onQuantityChange(e.target.value);
                  }}
                  onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()} // Prevent invalid characters
                  onWheel={(e) => e.target.blur()} // Prevent scrolling to change the value
                  style={{ width: "64px" }}
                  disabled={isGlobalLoading}
                />
              </td>
              {isShowPriceAccordingToProcess(selectedQuote) ? <td>
                {<div>
                  {
                    (props?.commanValues?.selectedShipMethod === 1 && !isGlobalLoading && !props?.commanValues?.isQuoteChanged && props?.singleValue?.price1) ? (
                      <div className="flex flex-col font-medium me-2">
                        <div>{currencyFormatter(props?.singleValue?.price1 * props?.singleValue?.Qty)}</div>
                        <div>{currencyFormatter(props?.singleValue?.price1)} <span className="text-slate-500">Each</span></div>
                      </div>
                    ) : (props?.commanValues?.selectedShipMethod === 2 && !isGlobalLoading && !props?.commanValues?.isQuoteChanged && props?.singleValue?.price2) ? (
                      <div>
                        <div className="flex flex-col font-medium me-2">
                          <div>{currencyFormatter(props?.singleValue?.price2 * props?.singleValue?.Qty)}</div>
                          <div>{currencyFormatter(props?.singleValue?.price2)} <span className="text-slate-500">Each</span></div>
                        </div>
                      </div>
                    ) : (props?.commanValues?.selectedShipMethod === 3 && !isGlobalLoading && !props?.commanValues?.isQuoteChanged && props?.singleValue?.price3) ? (
                      <div>
                        <div className="flex flex-col font-medium me-2">
                          <div>{currencyFormatter(props?.singleValue?.price3 * props?.singleValue?.Qty)}</div>
                          <div>{currencyFormatter(props?.singleValue?.price3)} <span className="text-slate-500">Each</span></div>
                        </div>
                      </div>
                    ) : isGlobalLoading ?
                      <SmallGlobalLoader
                        height={70}
                      />
                      : null
                  }

                </div>}
              </td> : null}


              <td className="text-center">
                {!isGlobalLoading ? <button
                  className="px-2 py-1 mt-2 bg-red-500 text-white text-xs rounded-md flex items-center gap-1 hover:bg-red-600 transition duration-200"

                  onClick={() => props.onDelete(index)}
                >
                  Delete
                </button> : <button className="w-6" ></button>}
              </td>
            </tr>
          )}

    </Fragment>
  )
};
export default ManualProcessLinesUI;



const maxFileChar = 52;

const FileName = ({ fileName, onDownload }) => {
  // Check if the filename needs truncation
  const isLong = fileName?.length > maxFileChar;
  const displayName = isLong ? fileName.slice(0, maxFileChar) + '...' : fileName;
  return (
    <div className="grid grid-cols-[1fr_auto] items-center w-full  max-w-md gap-2  py-2 rounded">
      <div className="text-primaryColor  ">{displayName}</div>
      <button
        onClick={onDownload}
        className="text-primaryColor hover:text-primaryColor"
        aria-label="Download"
      >
        <DownloadIcon className="w-5 h-5" />
      </button>
    </div>
  );
};